import { render, staticRenderFns } from "./TipoComboPorEtapa.vue?vue&type=template&id=044810c2&scoped=true&"
import script from "./TipoComboPorEtapa.vue?vue&type=script&lang=js&"
export * from "./TipoComboPorEtapa.vue?vue&type=script&lang=js&"
import style0 from "./TipoComboPorEtapa.vue?vue&type=style&index=0&id=044810c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044810c2",
  null
  
)

export default component.exports